import { createWolfswapAuthedApi } from '@/lib/api/clients/wolfswap';
import { reauthorizeSpeedJob } from '@/lib/api/speed';
import { queryClient, queryKeys } from '@/lib/query';

import {
    assertTradingAuthorityForRequest,
    handleTradingAuthorityRequired,
} from './clientAuthority';
import { clearLocalAuthentication } from './logout';

interface DurableJobResumeDependencies {
    reauthorize: (jobId: string, appToken: string) => Promise<void>;
    invalidateJobs: () => Promise<unknown>;
}

const defaultDependencies: DurableJobResumeDependencies = {
    reauthorize: async (jobId, appToken) => {
        const api = createWolfswapAuthedApi(
            () => appToken,
            clearLocalAuthentication,
            {
                beforeSignerMutation: assertTradingAuthorityForRequest,
                onTradingAuthorityRequired: handleTradingAuthorityRequired,
            },
        );
        await reauthorizeSpeedJob(api, jobId);
    },
    invalidateJobs: async () =>
        queryClient.invalidateQueries({ queryKey: queryKeys.speed.jobs() }),
};

/** Resume one unsigned durable job only after a fresh authority ceremony. */
export async function resumeDurableJob(
    jobId: string,
    appToken: string,
    dependencies: DurableJobResumeDependencies = defaultDependencies,
): Promise<void> {
    await dependencies.reauthorize(jobId, appToken);
    await dependencies.invalidateJobs();
}
